import React from 'react';
import { LogOut, LayoutDashboard, Heart, ChevronDown } from 'lucide-react';

const ITEM_CLS = 'w-full flex items-center space-x-2 px-4 py-3 text-sm text-gray-700 hover:bg-sand-50';

export const UserAvatarButton = ({ user, onClick }) => {
  const initial = (user.name || user.email || 'U').charAt(0).toUpperCase();
  return (
    <button type="button" data-testid="user-menu-button" onClick={onClick} className="flex items-center space-x-2 text-white border-2 border-white/30 rounded-full pl-1 pr-3 py-1 hover:bg-white/10 transition-all">
      {user.picture ? (
        <img src={user.picture} alt="" referrerPolicy="no-referrer" className="w-8 h-8 rounded-full object-cover" />
      ) : (
        <span className="w-8 h-8 rounded-full bg-gold-400 text-[#143160] font-bold flex items-center justify-center">{initial}</span>
      )}
      <span className="hidden sm:inline text-sm font-semibold max-w-[100px] truncate">{user.name || 'Account'}</span>
      <ChevronDown className="w-4 h-4" />
    </button>
  );
};

export const UserMenuDropdown = ({ user, onNavigate, onLogout }) => (
  <div data-testid="user-menu-dropdown" className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden z-50">
    <div className="px-4 py-3 border-b border-gray-100">
      <p className="text-sm font-bold text-[#143160] truncate">{user.name}</p>
      <p className="text-xs text-gray-500 truncate">{user.email}</p>
      {user.role === 'admin' && <span className="inline-block mt-1 text-[10px] font-bold uppercase tracking-wide text-gold-600 bg-gold-100 px-2 py-0.5 rounded-full">Admin</span>}
    </div>
    <button type="button" data-testid="menu-account" onClick={() => onNavigate('/account')} className={ITEM_CLS}>
      <Heart className="w-4 h-4 text-gold-600" /><span>My Saved Searches</span>
    </button>
    {user.role === 'admin' && (
      <button type="button" data-testid="menu-leads" onClick={() => onNavigate('/admin/leads')} className={ITEM_CLS}>
        <LayoutDashboard className="w-4 h-4 text-gold-600" /><span>Leads Dashboard</span>
      </button>
    )}
    <button type="button" data-testid="menu-logout" onClick={onLogout} className="w-full flex items-center space-x-2 px-4 py-3 text-sm text-red-600 hover:bg-red-50 border-t border-gray-100">
      <LogOut className="w-4 h-4" /><span>Sign Out</span>
    </button>
  </div>
);
